<div class="service-details-page">
  @if (service) {
    <section class="service-details-section animate-fade-in-up">
      <div class="service-details-layout">
        <div class="service-details-back-wrap">
          <button class="service-details-back" type="button" (click)="backToCapabilities()">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Directory Return
          </button>
        </div>
        <div class="service-details-grid">
          <div class="service-main">
            <h1 class="service-main__title">{{ service.title }}</h1>
            <p class="service-main__copy">{{ service.desc }}</p>
            <div class="service-block">
              <h2 class="service-block__heading">Key Offerings</h2>
              <ul class="service-keys">
                @for (key of service.keys; track key) {
                  <li>
                    <span></span>
                    {{ key }}
                  </li>
                }
              </ul>
            </div>
            <div class="service-block">
              <h2 class="service-block__heading">Success Topologies</h2>
              <div class="service-cases">
                @for (caseItem of service.cases; track caseItem) {
                  <article class="service-case">
                    <span class="service-case__tag">{{ caseItem.tag }}</span>
                    <h3 class="service-case__title">{{ caseItem.title }}</h3>
                    <div class="service-case__content">
                      <div>
                        <strong>The Challenge</strong>
                        <p>{{ caseItem.challenge }}</p>
                      </div>
                      <div>
                        <strong>The Solution</strong>
                        <p>{{ caseItem.solution }}</p>
                      </div>
                      <div class="service-case__outcome">
                        <strong>The Outcome</strong>
                        <p>{{ caseItem.outcome }}</p>
                      </div>
                    </div>
                  </article>
                }
              </div>
            </div>
          </div>
          <aside class="service-aside">
            <div class="service-aside__box">
              <h2 class="service-aside__title">Initiate Build</h2>
              <div class="service-aside__copy">
                Begin your journey to a more efficient, scalable, and secure cloud environment. Let's
                design your future-ready enterprise architecture.
              </div>
              <button type="button" class="service-aside__btn" (click)="openCalendlyPopup()">
                Direct Inquiry
              </button>
            </div>
          </aside>
        </div>
      </div>
    </section>
  } @else {
    <section class="service-empty">
      <div class="service-empty__title">404</div>
      <div class="service-empty__copy">This service detail is currently unavailable.</div>
      <button class="service-empty__btn" type="button" (click)="backToCapabilities()">Return to Services</button>
    </section>
  }


  <!-- <section id="contact" class="contact-section" aria-label="Contact Us">
  <div class="contact-section__container">
    <div class="contact-section__grid">
      <div>
        <div class="contact-section__eyebrow">Connect</div>
        <div class="contact-section__title">Discover the future of applied AI.</div>
        <div class="contact-section__copy">
          Connect with our delivery experts to audit your topology and map your enterprise integration
          roadmap.
        </div>
      </div>

      <div class="contact-card">
        <div class="contact-card__corner" aria-hidden="true"></div>
        <div class="contact-card__title">Direct Inquiry</div>

        <div *ngIf="submitted" role="alert" class="contact-card__success animate-fade-in-up">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          <div>Request securely logged. Our architecture team will reach out within one business day.
          </div>
        </div>

        <form *ngIf="!submitted" [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
          <div class="contact-form__field">
            <input type="text" formControlName="name" placeholder="Full Name" />
          </div>

          <div class="contact-form__row">
            <div class="contact-form__field">
              <input type="email" formControlName="email" placeholder="Corporate Email" />
            </div>
            <div class="contact-form__field">
              <input type="text" formControlName="company" placeholder="Organization" />
            </div>
          </div>

          <div class="contact-form__field">
            <textarea rows="3" formControlName="message"
            placeholder="Brief context of operational challenges..."></textarea>
          </div>

          <button type="submit" [disabled]="contactForm.invalid || isSubmitting"
            class="contact-form__submit">
            <span *ngIf="!isSubmitting">Transmit Request</span>
            <span *ngIf="isSubmitting" class="contact-form__submit-loading">
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <circle cx="12" cy="12" r="10"></circle>
                <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
              </svg>
              Encrypting...
            </span>
          </button>
        </form>
      </div>
    </div>
  </div>
</section> -->
</div>
